import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "open-question-chapter-view"
};
const _hoisted_2 = {
  class: "open-question-chapter-title"
};
const _hoisted_3 = {
  class: "open-question-chapter-preamble"
};
const _hoisted_4 = {
  class: "open-question-inputs-container"
};
const _hoisted_5 = {
  class: "open-question-input-block"
};
const _hoisted_6 = {
  class: "open-question-input-label"
};
const _hoisted_7 = {
  class: "open-question-time-limit-block"
};
const _hoisted_8 = {
  class: "open-question-time-limit-label"
};
const _hoisted_9 = {
  class: "open-question-detail-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_input = _resolveComponent("w-input");
  const _component_quiz_html_editor = _resolveComponent("quiz-html-editor");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('chapter.openQuestionView.title')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('chapter.openQuestionView.preamble')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('chapter.openQuestionView.questionLabel.title')), 1), _createVNode(_component_w_input, {
    class: "open-question-input",
    value: _ctx.openQuestion?.label,
    placeholder: _ctx.$t('chapter.openQuestionView.questionLabel.placeholder'),
    onChangeInput: _cache[0] || (_cache[0] = $event => _ctx.onOpenQuestionLabelChange($event))
  }, null, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('chapter.openQuestionView.timeLimit.title')), 1), _createVNode(_component_w_input, {
    class: "open-question-time-limit-input",
    value: _ctx.quizContent?.timer,
    placeholder: _ctx.$t('chapter.openQuestionView.timeLimit.placeholder'),
    onChangeInput: _cache[1] || (_cache[1] = $event => _ctx.onTimeLimitChange($event))
  }, null, 8, ["value", "placeholder"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_quiz_html_editor, {
    editorId: _ctx.openQuestionDetailEditorId,
    "custom-editor-config": _ctx.openQuestionDetailEditorConfig,
    "editor-title": _ctx.$t('chapter.openQuestionView.complementaryInfo.title'),
    content: _ctx.realtimeComplementaryInfo,
    onBlur: _ctx.onComplementaryInfoChange
  }, null, 8, ["editorId", "custom-editor-config", "editor-title", "content", "onBlur"])])]);
}